import { $fetch } from 'ofetch'

export async function apiGet<T>(path: string): Promise<T> {
  const { requestOptions } = useRequestOptions()

  return $fetch<T>(path, {
    method: 'GET',
    ...requestOptions
  })
}
